<template>
  <div class="toastMessage notranslate">
    {{message}}
  </div>
</template>

<script>
export default {
  props: [
    'locale',
    'lang',
    'message'
  ],
  computed: {
  },
  mounted () {
    window.addEventListener('click', this.onClick)
    window.addEventListener('touchstart', this.onClick)
    setTimeout(() => {
      this.close()
    }, 3000)
  },
  beforeDestroy () {
    window.removeEventListener('click', this.onClick)
    window.removeEventListener('touchstart', this.onClick)
  },
  data () {
    return {
    }
  },
  methods: {
    onClick (e) {
      e.stopPropagation()
      this.close()
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.toastMessage {
  position: fixed;
  top: 50%;
  left: 50%;
  max-width: calc(100% - 60px);
  padding: 12px 20px;
  font-size: 32px;
  color: $color-white;
  border-radius: 12px;
  background-color: $color-dark;
  transform: translate(-50%, -50%);
  z-index: 99999999;
}
</style>
